import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';

interface BaseBlackAndWhiteOptionProps {
  isChecked: boolean;

  onToggleOption(): void;
}

export function BaseBlackAndWhiteOption({...props}: BaseBlackAndWhiteOptionProps): ReactElement<any> {
  const onClickHandler = (): void => {
    props.onToggleOption();
  };

  return <ContextualMenuToggleOption id="item-black-and-white-option" label={window.i18next.t('pmwjs_black_and_white')} isChecked={props.isChecked} onClick={onClickHandler} />;
}
